// extracted by mini-css-extract-plugin
export default {"WidgetBody":"WidgetBodyWithIcon_WidgetBody__NWSUs","LargeWidgetBody":"WidgetBodyWithIcon_LargeWidgetBody__oSlKo"};